
<div
  tabindex="0"
  :data-id="objectModelRelation.client_id"
  :data-type="relationType"
  class="form-element"
  :class="relationshipClasses"
  v-on:focus="replaceIdInRoute($event, true)"
  @click.stop="replaceIdInRoute"
>
  <div class="title-bar">
    <column class="row-title" v-if="objectModelRelation.can(ObjectModelRelationCapability.labelable)">
      <p>
        <strong id="relation_type_display_name">{{getDisplayName(relationType)}}</strong>
      </p>
    </column>
    <move-destroy
      :card="objectModelRelation"
      @remove:card="confirmDelete"
      :disabled="disabled"
      class="suffix"
    ></move-destroy>
  </div>
  <row>
    <column :size="isAccountRelationship ? 250 : 180">
      <object-model-relation-labelable
        :object-model-relation="objectModelRelation"
        :can-configure="!disabled"
        v-if="!objectModelRelation.hasExternalOrigin"
      ></object-model-relation-labelable>
      <label id="inverse_label_title" v-else>{{objectModelRelation.inverseLabelTitleOrDefault}}</label>
    </column>

    <column size="120" v-if="!isAccountRelationship">
      <p id="relation_type_friendly_name">{{getFriendlyName(relationType)}}</p>
    </column>

    <column size="180" v-if="!isAccountRelationship">
      <p id="inverse_relationship_title">
        <strong>{{objectModelRelation.inverseRelationshipTitle}}</strong>
      </p>
    </column>
  </row>
  <row v-if="!isAccountRelationship">
    <column size="285">
      <p>From Related Object Model(s)</p>
    </column>
    <column>
      <p v-html="relatedModelsSentence" id="related_models_sentence"></p>
    </column>
  </row>

  <confirm-delete-object-model-relationship-modal
    :state="modalStateFor(vueModalID.confirmDeleteObjectModelRelationship)"
    :index="vueModalID.confirmDeleteObjectModelRelationship"
    :relationship="objectModelRelation"
    @toggle-modal="hideModal(vueModalID.confirmDeleteObjectModelRelationship)"
    @remove="remove"
    v-if="modalStateFor(vueModalID.confirmDeleteObjectModelRelationship).isVisible">
  </confirm-delete-object-model-relationship-modal>
</div>
